import { getEnv } from "@lib/environment";

const BILLCOM_SANDBOX_BASE_URL = "https://app-stage02.us.bill.com";
const BILLCOM_PROD_BASE_URL = "https://app.bill.com";

export function isBillcomSandbox(): boolean {
    return (
        getEnv("VITE_BILLCOM_SANDBOX") === "true" ||
        getEnv("KICK_ENV") === "develop"
    );
}

export function getBillcomBaseUrl(): string {
    return isBillcomSandbox()
        ? BILLCOM_SANDBOX_BASE_URL
        : BILLCOM_PROD_BASE_URL;
}
